import { ButtonColors } from '@chiroup/components/Button';
import { OpenClosedStates } from '@chiroup/components/states';
import { isEmpty } from '@chiroup/core/functions/isEmpty';
import { User, UserRoles } from '@chiroup/core/types/User.type';
import { useForm } from '@chiroup/hooks/useForm';
import React, { use, useEffect, useState } from 'react';
import { ToastContext, ToastTypes } from '../../contexts/toast.context';
import userService from '../../services/user.service';
import Modal from '../common/Modal';
import UserGeneralFormElements from './detail/UserGeneralFormElements';

const validation = {
  title: {
    required: {
      message: 'Title is required.',
    },
  },
  fname: {
    required: {
      message: 'First name is required.',
    },
  },
  lname: {
    required: {
      message: 'Last name is required.',
    },
  },
  email: {
    required: {
      message: 'Email is required.',
    },
  },
  phone: {
    function: {
      value: (value: Partial<NewUser>) => {
        const { phone } = value;

        if (phone?.[1] === '1' && phone?.split(' ')?.[0]?.length === 6 && phone?.length < 13) {
          return 'Phone number must be 7 digits.';
        } else if (phone?.[1] === '1' && phone?.length < 13) {
          return 'Phone number must be 10 digits.';
        }

        return false;
      },
    },
  },
  // role: {
  //   required: {
  //     message: 'User role is required.',
  //   },
  // },
};

type Props = {
  state: OpenClosedStates;
  close: (val?: User) => void;
  onCreate?: () => void;
  // lastName?: string;
  clinicID?: number;
  isEHR?: boolean;
};

type NewUser = User & {
  clinicID: number;
  role: UserRoles[];
};

const UserCreate: React.FC<Props> = ({
  state,
  close,
  onCreate,
  clinicID,
  // lastName,
  isEHR,
}) => {
  const { value, registerSubmit, isDirty, errors, onChange, patchValue } = useForm<NewUser>(
    { title: 'Dr' },
    validation
  );
  const [saving, setSaving] = useState(false);
  const { createToast } = use(ToastContext);

  useEffect(() => {
    if (!isEmpty(clinicID)) {
      patchValue({ clinicID });
    }
  }, [clinicID, patchValue, state]);

  const onSubmit = async (user: Partial<User>) => {
    setSaving(true);

    try {
      const res = await userService.create(user);
      setSaving(false);
      close(res);

      return res;
      // onCreate();
    } catch (err) {
      console.error(err);
      setSaving(false);
    }

    return user;
  };

  const onSuccess = (data: User) => {
    createToast({
      title: 'Successfully created user!',
      description: null,
      type: ToastTypes.Success,
      duration: 5000,
    });
    close();
    onCreate?.();
  };

  return (
    <Modal
      isOpen={state === OpenClosedStates.Open}
      close={() => close()}
      header={{ title: 'Add user' }}
      footer={{
        buttons: [
          {
            text: 'Close',
            onClick: () => close(),
            color: ButtonColors.plain,
            className: 'border border-gray-300 dark:border-dark-gray-500',
          },
          {
            text: 'Create',
            onClick: registerSubmit(onSubmit, {
              onSuccess,
            }),
            loading: saving,
            disabled: !isDirty,
          },
        ],
      }}
      darkBg
    >
      <div className="space-y-1 sm:space-y-0 sm:grid sm:grid-cols-4 sm:gap-4 sm:py-5">
        <UserGeneralFormElements
          fieldErrors={errors.fieldErrors}
          value={value}
          onChange={onChange}
          patchValue={patchValue}
          clinicID={clinicID}
          isEHR={isEHR}
        />
      </div>
    </Modal>
  );
};

export default UserCreate;
